import { Link, useNavigate, Navigate, useParams } from "react-router"
import { useQueryClient } from "@tanstack/react-query"

import MainLayout from "../_layouts/Main"
import AddAccountForm from "../../sections/AccountInfo/AccountInfoForm"
import { useAccount, useIsMultiAccount } from "../../hooks"
import useIsNew from "../../hooks/useIsNew"
import { AccountRoleType, AccountTypes } from "../../types/account"

export interface InitialAccountValuesTypes {
  account_name: string
  email: string
  first_name: string
  last_name: string
  phone_number: string
  role: AccountRoleType
}

const initialAccountValues: InitialAccountValuesTypes = {
  account_name: "",
  email: "",
  first_name: "",
  last_name: "",
  phone_number: "",
  role: "admin",
}

const AccountInfo = () => {
  const navigate = useNavigate()
  const { accountId } = useParams()
  const isMultiAccount = useIsMultiAccount()
  const queryClient = useQueryClient()
  const isNew = useIsNew()
  const { data: account, isLoading: accountIsLoading } = useAccount<
    AccountTypes,
    Error
  >(queryClient, accountId as string, {
    enabled: !isNew,
  })

  function handleSuccess(account: AccountTypes) {
    if (isNew) {
      navigate(`/accounts/${account.id}/onboarding/account-info`, {
        replace: true,
      })
    } else {
      navigate(`/accounts/${account.id}/onboarding/property-boundaries`)
    }
  }

  if (isNew && !isMultiAccount) {
    return <Navigate replace to="/" />
  }

  return (
    <MainLayout
      isLoading={isNew ? [] : [accountIsLoading]}
      contentBg="bg-white"
    >
      <div className="container">
        <div className="inner-container mx-auto">
          <div className="mt-6 mb-4 md:mt-10 md:mb-8">
            <h3
              className="text-2xl leading-[1.40] tracking-[0.03em]"
              data-testid="account-info-title"
            >
              Add an Account
            </h3>
          </div>

          <div className="mb-10 flex flex-col w-full md:flex-row md:flex-wrap">
            <div className="w-full">
              {isNew || !!account ? (
                <AddAccountForm
                  backLink={
                    <Link to={isNew ? "/" : `/accounts/${account?.id}`}>
                      {isNew ? "Cancel" : "Back"}
                    </Link>
                  }
                  initialValues={isNew ? initialAccountValues : account!}
                  onSuccess={handleSuccess}
                  page="onboarding"
                  submitText="Save and Continue"
                />
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </MainLayout>
  )
}

export default AccountInfo
